const carrierChannelTypeEnum = {
	requiredCarrier: 0,
	buyShipping: 1,
	trackingCarrier: 2
};

export { carrierChannelTypeEnum };
